import React from "react";

import { Navigate } from "react-router-dom";

import { AppRoute } from "@/shared/domain";
import { useRouterHook } from "@/shared/hooks";

/**
 * /tariffication/132139?o=89005&dl=true
 * /packagestosign?o=89005&sc=CfDJ8Lu6QCbd8lpPk+UOeVqo4C76b/xX0TN9QEFUArCdll4Df2n3JF9Gofka2ZBymntypbmE5doohRt1Bt9g6ZQ28i5Hhdv3uZ11LbSkb3R5LgBgNj3s2WOw4+dppBNPjhQU2I7DLleX8/uSmVLAeDWYtCSvCUwzmgH5B8msFazKJ3iE29s1X/aqZ6K2Q75HlKS73xwxpx1WiHJLyv7xenbPWCXR66CbZKugaNMFQr7Q3W2mzQqO+em/qXNPC9rbjOz9LgXIuz8CuIf3faxgfAQ7u6I0ceygVNv2lDRlIQpUvZlgLZn3MPbuZxLHoj8nFhX05YXocrGGcIc+qEYkSEvwVI5NTNpW0rYk72H475EMNk09X+1L/VdtCsIOxop+v9OeBaGbIyeNcfhRpfUrV8Qhfme8xcM+NrgxCmmgiGhwY4X10VvXPSC9K4C4KReCyGKsXa5RaXCVuNdS0SOUeby/l8x3higI/tBsP/ywh2Esuwat/CkYtrgzmpOcpKqrl8xgtb+nfZkDfNkfJv3kp9AvpaV7JIy6o9wzgcKCR/fC1yRxPRplRXTBdy+CFtyV30QCyT/dQ14rbVvcEE1JkPT59nGLpdBv4AqXJq1I2AsywtLw8t3h9Me4gqMQYbkZDTpfW/VfY1w0HgcKt91UfuslNthWr2G8/fSO4dnKcD9KNLouxx/wgoUY0D166xI0MaD3Chn0Nzl9OQmRSMlNOE8SVaybXBsWfT5FIZdSqNsQyfJX
 * /packagestosign/154733?o=15004&dl=true
 * /?o=89005&sc=NO4NqhM60JPzoxLMTOCciBEFQq39MPzv4U%2fWjiGnSVXEdp9D%2fqqvUoVcmtbDZ9yV%2bzOmMgds8WhuNYIv%2banWoRcTkmTwKOdkINbSeXwkFom9fafbnW65nvp%2b3DdN59qhMbDq1kgWZ%2bKQ3In5MubW5xZfC0MFum%2fJuDk5HHMfsSkvsz4N6Xt2vLU2XCTT2q%2bvBjPW3mR03kBY9yNn3BeXq5pAhfZ%2fj802x1WMBx7iGBWtTf0EqZbpJ%2fFIVgfeHifXj%2bW2aUS2BnYotuuNQgxBzsXl%2fLTm2FB0w%2bOPlUjCb5FGPI5Igwg9E9CmFdsUhQnIdo%2bQWI12vvqCA%2f7%2flPvbTHEHyI0xS%2fSApOlmfuVAp%2f6SldL2ezsTDTwaCngv1noJdq6TYpu5VacAmhP7fCQnv760ai1gBwgajGZ3GXX2YQyXsfkHCOpLkuwc2zuAZeWWaK1hmszw8JGdKde%2fF38b1J9m0OsKE1NO%2fxZDist60SeK7tPrnpFpxuPNqVGy7SGUgqVnnm7k7lDnbkrhAGL5DS8WlqJK4ic5fZ%2fTRpww0TDCqo%2bXXLHjvQrHeGir7lQt1TNph5f1u9yjhV%2fQVijQaQiil8qOkrYfkRFmRihQwX1O3jDEH1DCD%2bJy5gqSfxX4BVDDO504Hr22wpXSDtNfLg%3d%3d
 */

const RedirectComponent = () => {
    const {
        search: { dl, sc },
        globalState: { officeId },
        pathname,
        searchRaw,
    } = useRouterHook();
    const hasScope = !!sc;

    if (hasScope) {
        return <></>;
    }

    const directLink = dl && dl === "true";
    const state = directLink ? { pathname, search: searchRaw } : {};

    return (
        <Navigate
            to={{
                pathname: AppRoute.Root,
                search: officeId ? `?o=${officeId}` : "",
            }}
            replace
            state={state}
        />
    );
};

export default RedirectComponent;
